export enum JobStatus {
  READY = "READY",
  CREATED = "CREATED",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  ABORTED = "ABORTED",
}
